(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.ttbReady === 'true') return;

    var track = section.querySelector('[data-ttb-track]');
    if (!track) return;

    section.dataset.ttbReady = 'true';

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          track.classList.toggle('is-paused', !entry.isIntersecting);
        });
      }, { threshold: 0 });

      observer.observe(section);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-ttb]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
